import React, { FC } from 'react';

import { BaseSkeleton } from './BaseSkeleton';

import { cn } from '@/shared/lib/tailwind-merge';

export enum SkeletonSize {
    Small = 'small',
    Default = 'default',
    Large = 'large',
    Avatar = 'avatar',
    Button = 'button',
}

interface SkeletonProps {
    size?: SkeletonSize;
    className?: string;
}

interface SkeletonComponent extends FC<SkeletonProps> {
    sizes: typeof SkeletonSize;
}

const Skeleton: SkeletonComponent = ({ size = SkeletonSize.Default, className }) => {
    const sizeStyles = {
        [SkeletonSize.Small]: 'w-[40px] h-[16px]',
        [SkeletonSize.Default]: 'w-[64px] h-[16px]',
        [SkeletonSize.Large]: 'w-[112px] h-[36px]',
        [SkeletonSize.Avatar]: 'w-[32px] h-[32px] rounded-full',
        [SkeletonSize.Button]: 'w-[112px] h-[36px]',
    };

    return <BaseSkeleton className={cn(sizeStyles[size], className)} />;
};

Skeleton.sizes = SkeletonSize;

export { Skeleton };
